// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__1Lz7k","frame":"Dialog_frame__O70sK","closeButton":"Dialog_closeButton__2n1xc","okButton":"Dialog_okButton__3PaiK","body":"Dialog_body__1RI3r"};